import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EditPlaylistModal } from './EditPlaylistModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditPlaylistModalTrigger = ({
  playlistId,
  renderTrigger
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderTrigger ? renderTrigger({
      openModal,
      isOpen
    }) : /*#__PURE__*/_jsx(Button, {
      onClick: openModal,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.editDetails"
      })
    }), isOpen && /*#__PURE__*/_jsx(EditPlaylistModal, {
      onRequestClose: closeModal,
      playlistId: playlistId
    })]
  });
};